import { Component, inject, OnInit, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BillingAddressComponent } from './billing-address/billing-address.component';
import { GeneralAccountComponent } from './general-account/general-account.component';
// Hidden for now (re-add to imports + template to restore):
// import { NotificationSettingsComponent } from './notification-settings/notification-settings.component';
// import { IntegrationsSettingsComponent } from './integrations-settings/integrations-settings.component';
import { ResponsiveBaseComponent } from 'shared-lib';
import { ParkerService, RegisteredParkerDto, BillingAddressDto } from '../../api/gen';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { JkuUserService } from '../jku-webshop/jku-user.service';

@Component({
  selector: 'app-my-account',
  imports: [BillingAddressComponent, GeneralAccountComponent, MatProgressSpinnerModule, TranslatePipe],
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent extends ResponsiveBaseComponent implements OnInit {
  private readonly parkerService = inject(ParkerService);
  private readonly jkuUser = inject(JkuUserService);

  /**
   * JKU SSO parkers get their identity from the JKU IdP (not self-editable) and JKU
   * handles their billing — so for them name/email are shown read-only and the billing
   * card is hidden. Local / self-registered parkers keep the editable, full account page.
   */
  readonly isJku = this.jkuUser.isJkuSso;

  readonly accountData = signal<RegisteredParkerDto | null>(null);
  readonly billingAddress = signal<BillingAddressDto | null>(null);
  readonly isLoading = signal(true);

  ngOnInit(): void {
    this.parkerService.parkerMePost().subscribe({
      next: (data) => {
        this.accountData.set(data);
        this.billingAddress.set(data.accountDetails?.billingAddress ?? null);
        this.isLoading.set(false);
      },
      error: () => {
        this.isLoading.set(false);
      }
    });
  }
}

